/*
 * Sort function for unselected choices. Sorts by
 * category name, alphabetically.
 */
export const unselectedChoicesSort = (choiceA, choiceB) => {
  const nameA = choiceA[0][0];
  const nameB = choiceB[0][0];
  if (nameA < nameB) {
    return -1;
  }
  if (nameA > nameB) {
    return 1;
  }
  return 0;
};

/*
 * Returns sort function for sorting selected choices
 * @param {orderedCategories} array of category ids containing ordering
 */
export const getSelectedChoicesSort =
  (orderedCategories) => (choiceA, choiceB) => {
    const indexA = orderedCategories.indexOf(choiceA[0][0]);
    const indexB = orderedCategories.indexOf(choiceB[0][0]);
    return indexA - indexB;
  };

/*
 * Returns sort function for sorting selections
 * @param {orderedCategories} array of category ids containing ordering
 */
export const getSelectionsSort =
  (orderedCategories) => (categoryA, categoryB) => {
    const indexA = orderedCategories.indexOf(categoryA[0]);
    const indexB = orderedCategories.indexOf(categoryB[0]);
    return indexA - indexB;
  };

/*
 * Determine if a category or category's child value
 * is selected.
 * @param {child} category child value. Leave null to
 *   check for category selection.
 */
export const isSelected = (selections, category, child = null) => {
  for (const [selectedCategory, selectedChildren] of selections) {
    if (selectedCategory === category) {
      if (child) {
        return selectedChildren.includes(child);
      }
      return true;
    }
  }
  return false;
};
